import CustomerService from '../services/CustomerService';
import ErrorHandler from '../helpers/ErrorHandler';
import CustomerConstants from '../constants/CustomerConstants';

export default {
  getList: (filter) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    CustomerService.list(filter).then((response) => {
      dispatch({type: 'OFF_BUSY'});
      dispatch({
        type: CustomerConstants.CUSTOMER_GET_LIST,
        payload: response.customers
      })
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err)
    })
  },
  getCount: () => dispatch => {
    CustomerService.getCount().then((response) => {
      dispatch({
        type: CustomerConstants.CUSTOMER_GET_COUNT,
        payload: response.count
      })
    }, (err) => {
      ErrorHandler(err)
    })
  }
}


/** WEBPACK FOOTER **
 ** ./src/actions/CustomerAction.js
 **/